import {
  SET_FB_USER,
  SET_USER,
  SET_USER_STATUS
} from '@/store/mutation-types'
import firebase, { firebaseAuth } from '@/vendor/firebase'
import l from '@/vendor/logger'

// ustatus
// null
// SIGN_IN
// SIGN_IN_PENDING
// SIGN_IN_FAILED
// SIGN_OUT

const auth = firebase.auth()

const state = {
  user: {},
  fbUser: null,
  ustatus: null
}

const getters = {
  user (state) { return state.user },
  userStatus (state) { return state.ustatus },
  isSignIn (state) { return state.ustatus === 'SIGN_IN' },
  isSignInPending (state) { return state.ustatus === 'SIGN_IN_PENDING' }
}

const mutations = {
  [SET_USER] (state, payload) {
    state.user = payload
  },

  [SET_USER_STATUS] (state, payload) {
    state.ustatus = payload
  }
}

const actions = {
  async signInGoogle ({ state, commit }) {
    try {
      if (state.ustatus !== 'SIGN_IN') {
        commit(SET_USER, 'SIGN_IN_PENDING')
        await auth.signInWithPopup(new firebaseAuth.GoogleAuthProvider())
      } else {
        throw new Error('auth/already-signed')
      }
    } catch (err) {
      if (err.message === 'auth/already-signed') { l.e(err); return }
      commit(SET_USER_STATUS, 'SIGN_IN_FAILED')
      l.e(err)
    }
  },

  signOut ({ commit, rootGetters }) {
    auth.signOut()
    // Cast일때 signout이면 방송타입에 null를 넣도록
    commit(SET_USER_STATUS, 'SIGN_OUT')
  },

  onAuthStateChanged ({ commit }) {
    auth.onIdTokenChanged(user => {
      if (user) {
        user.getIdToken().then(token => {
          commit(SET_FB_USER, token, { root: true })
        })
      }
    })
    auth.onAuthStateChanged((user) => {
      if (user) {
        user.getIdToken().then(token => {
          commit(SET_FB_USER, token, { root: true })
        })
        commit(SET_USER, user.toJSON())
        commit(SET_USER_STATUS, 'SIGN_IN')
      } else {
        commit(SET_USER, null)
        commit(SET_USER_STATUS, 'SIGN_OUT')
      }
    })
  }
}

export default {
  namespaced: true,
  state,
  getters,
  mutations,
  actions
}
